import React from 'react';

import { MenuTabsWrap } from 'features/menu/components/menu-tabs';
import { MainMenuPage } from 'features/menu/pages/main-menu-page';
import { MainMenuPageV2 } from 'features/menu/pages/main-menu-page-v2';
import { MainMenuPage as MainMenuBadgesExperiment } from 'features/menu/pages/main-menu-page/main-menu-badges-experiment';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { useAcceleratorBadgesOnMenuExperiment } from 'experiments/use-accelerator-badges-on-menu-experiment';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';

export default function MenuScreen() {
  useStoreRequired();

  return <MenuInner />;
}

const MenuInner = React.memo(() => {
  const enableUnifiedMenu = useEnableUnifiedMenu();
  const enableMenuAcceratorBadgesExperiment = useAcceleratorBadgesOnMenuExperiment();
  return (
    <MenuTabsWrap>
      {enableUnifiedMenu ? (
        <MainMenuPageV2 />
      ) : enableMenuAcceratorBadgesExperiment ? (
        <MainMenuBadgesExperiment />
      ) : (
        <MainMenuPage />
      )}
    </MenuTabsWrap>
  );
});
